import { render, staticRenderFns } from "./save-modal.component.vue?vue&type=template&id=ff5f7cb8&scoped=true"
import script from "./save-modal.component.vue?vue&type=script&lang=js"
export * from "./save-modal.component.vue?vue&type=script&lang=js"
import style0 from "./save-modal.component.vue?vue&type=style&index=0&id=ff5f7cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5f7cb8",
  null
  
)

export default component.exports